import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

// Containment Action

const setContainmentActionsLocations = (state, { containmentactionlocationData }) => {
  return state.merge({ containmentactionlocationData });
};

const setContainmentActionsLocationLoader = (state, { containmentActionsLocationsLoader }) => {
  return state.merge({ containmentActionsLocationsLoader });
};

const setContainmentActionsLocationById = (state, { containmentActionsLocationById }) => {
  return state.merge({ containmentActionsLocationById });
};

const setaddUpdateContainmentActionsLocation = (state, { addUpdateContainmentActionsLocationObj }) => {
  return state.merge({ addUpdateContainmentActionsLocationObj });
};

//Metric
const setContainmentActionsMetricsType = (state, { containmentactionmetricTypes }) => {
  return state.merge({ containmentactionmetricTypes });
};

const setContainmentActionsMetrics = (state, { containmentactionmetricData }) => {
  return state.merge({ containmentactionmetricData });
};

const setContainmentActionsMetricLoader = (state, { containmentActionsMetricLoader }) => {
  return state.merge({ containmentActionsMetricLoader });
};

const setContainmentActionsStep3Loader = (state, { containmentActionsStep3Loader }) => {
  return state.merge({ containmentActionsStep3Loader });
};

const setContainmentActionsMetricById = (state, { containmentActionsMetricById }) => {
  return state.merge({ containmentActionsMetricById });
};

const setContainmentActionsStep3ById = (state, { containmentActionsStep3 }) => {
  return state.merge({ containmentActionsStep3 });
};

const setaddUpdateContainmentActionsMetric = (state, { addUpdateContainmentActionsMetricObj }) => {
  return state.merge({ addUpdateContainmentActionsMetricObj });
};

// Quality Assurance Complaint

const setQualityAssuranceComplaint = (state, { qualityAssuranceComplaintData }) => {
  return state.merge({ qualityAssuranceComplaintData });
};

const setQualityAssuranceComplaintChart = (state, { qualityAssuranceComplaintchartData }) => {
  return state.merge({ qualityAssuranceComplaintchartData });
};

const setQualityAssuranceComplaintFactory = (state, { qualityAssuranceContactbyidData }) => {
  return state.merge({ qualityAssuranceContactbyidData });
};
// 8d that are not attach with complaint
const eightdNotAttachedLoader = (state, { eightdNotAttachedLoader }) => {
  return state.merge({ eightdNotAttachedLoader });
};

const setEightdNotAttached = (state, { eightdNotAttachedData }) => {
  return state.merge({ eightdNotAttachedData });
};

// compliant that are not attach with 8d
const complaintNotAttachedLoader = (state, { complaintNotAttachedLoader }) => {
  return state.merge({ complaintNotAttachedLoader });
};

const setComplaintNotAttached = (state, { complaintNotAttachedData }) => {
  return state.merge({ complaintNotAttachedData });
};

const setSingleComplaintObj = (state, { singleComplaintObj }) => {
  return state.merge({ singleComplaintObj });
};

const setComplaintFiles = (state, { filesUrl }) => {
  return state.merge({ filesUrl });
};

const setQualityAssuranceComplaintLoader = (state, { qualityAssuranceComplaintLoader }) => {
  return state.merge({ qualityAssuranceComplaintLoader });
};
const setQualityAssuranceComplaintChartLoader = (state, { qualityAssuranceComplaintChartLoader }) => {
  return state.merge({ qualityAssuranceComplaintChartLoader });
};
const setQualityAssuranceComplaintFileLoader = (state, { qualityAssuranceComplaintFileLoader }) => {
  return state.merge({ qualityAssuranceComplaintFileLoader });
};

const setQualityAssuranceEightdProcessLoader = (state, { qualityAssuranceEightdProcessLoader }) => {
  return state.merge({ qualityAssuranceEightdProcessLoader });
};

const setQACreatedUpdatedComplaintObj = (state, { qaCreatedUpdatedComplaintObj }) => {
  return state.merge({ qaCreatedUpdatedComplaintObj });
};

const setQualityAssuranceEightdProcessRef = (state, { qualityAssuranceEightdProcessRefData }) => {
  return state.merge({ qualityAssuranceEightdProcessRefData });
};

const setQualityAssuranceEightdProcess = (state, { qualityAssuranceEightdProcessData }) => {
  return state.merge({ qualityAssuranceEightdProcessData });
};

const setQACreatedUpdatedEightdProcessObj = (state, { qaCreatedUpdatedEightdProcessObj }) => {
  return state.merge({ qaCreatedUpdatedEightdProcessObj });
};

const setQualityAssuranceTilesData = (state, { qualityAssuranceTilesData }) => {
  return state.merge({ qualityAssuranceTilesData });
};

const setQualityAssuranceEidghtDUniqueRef = (state, { qualityAssuranceEidghtDUniqueData }) => {
  return state.merge({ qualityAssuranceEidghtDUniqueData });
};

const setQualityAssuranceComplaintUniqueRef = (state, { qualityAssuranceComplaintUniqueData }) => {
  return state.merge({ qualityAssuranceComplaintUniqueData });
};

const setFilesForDownload = (state, { downloadContainmentActionDocFile }) => {
  if (!downloadContainmentActionDocFile) return state;
  return state.merge({ downloadContainmentActionDocFile });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_METRICS_TYPE_LIST,
    actionFunction: setContainmentActionsMetricsType,
  },

  {
    actionType: ActionTypes.SET_ADD_UPDATE_CONTAINMENT_ACTIONS_METRIC,
    actionFunction: setaddUpdateContainmentActionsMetric,
  },

  {
    actionType: ActionTypes.SET_ADD_UPDATE_CONTAINMENT_ACTIONS_LOCATION,
    actionFunction: setaddUpdateContainmentActionsLocation,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_METRIC_LOADER_STATUS,
    actionFunction: setContainmentActionsMetricLoader,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_STEP3_LOADER_STATUS,
    actionFunction: setContainmentActionsStep3Loader,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_METRICS,
    actionFunction: setContainmentActionsMetrics,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATION_BY_ID,
    actionFunction: setContainmentActionsLocationById,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATION_LOADER_STATUS,
    actionFunction: setContainmentActionsLocationLoader,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_LOCATIONS,
    actionFunction: setContainmentActionsLocations,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT,
    actionFunction: setQualityAssuranceComplaint,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_CHART,
    actionFunction: setQualityAssuranceComplaintChart,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_REf_UNIQUE,
    actionFunction: setQualityAssuranceComplaintUniqueRef,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_EightD_UNIQUE,
    actionFunction: setQualityAssuranceEidghtDUniqueRef,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FACTORY,
    actionFunction: setQualityAssuranceComplaintFactory,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_METRIC_BY_ID,
    actionFunction: setContainmentActionsMetricById,
  },

  {
    actionType: ActionTypes.SET_CONTAINMENT_ACTIONS_STEP3_BY_ID,
    actionFunction: setContainmentActionsStep3ById,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_STATUS,
    actionFunction: setQualityAssuranceComplaintLoader,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_LOADER_CHART_STATUS,
    actionFunction: setQualityAssuranceComplaintChartLoader,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FILE_LOADER_STATUS,
    actionFunction: setQualityAssuranceComplaintFileLoader,
  },

  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_COMPLAINT_FILES,
    actionFunction: setComplaintFiles,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CREATED_UPDATED_COMPLAINT_OBJ,
    actionFunction: setQACreatedUpdatedComplaintObj,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_CREATED_UPDATED_EIGHTDPROCESS_OBJ,
    actionFunction: setQACreatedUpdatedEightdProcessObj,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS_LOADER_STATUS,
    actionFunction: setQualityAssuranceEightdProcessLoader,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS,
    actionFunction: setQualityAssuranceEightdProcess,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_EIGHTDPROCESS_REF,
    actionFunction: setQualityAssuranceEightdProcessRef,
  },
  {
    actionType: ActionTypes.SET_SINGLE_COMPLAINT_OBJ,
    actionFunction: setSingleComplaintObj,
  },
  {
    actionType: ActionTypes.SET_QUALITY_ASSURANCE_TILES_DATA,
    actionFunction: setQualityAssuranceTilesData,
  },

  {
    actionType: ActionTypes.LOADER_8D_NOT_ATTACHED,
    actionFunction: eightdNotAttachedLoader,
  },
  {
    actionType: ActionTypes.SET_8D_NOT_ATTACHED,
    actionFunction: setEightdNotAttached,
  },
  {
    actionType: ActionTypes.LOADER_COMPLAINT_NOT_ATTACHED,
    actionFunction: complaintNotAttachedLoader,
  },
  {
    actionType: ActionTypes.SET_COMPLAINT_NOT_ATTACHED,
    actionFunction: setComplaintNotAttached,
  },
  {
    actionType: ActionTypes.SET_FILES_FOR_DOWNLOAD,
    actionFunction: setFilesForDownload,
  },
];
